import { render, staticRenderFns } from "./TankManufacturerProfile.vue?vue&type=template&id=6f36414f"
import script from "./TankManufacturerProfile.vue?vue&type=script&lang=js"
export * from "./TankManufacturerProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports